import { ThemeProvider as NextThemesProvider } from 'next-themes';

export function ThemeProvider({
  children,
  ...props
}: {
  children: React.ReactNode;
  props: {
    attribute: string;
    defaultTheme: string;
    enableSystem: boolean;
  };
}) {
  return <NextThemesProvider {...props}>{children}</NextThemesProvider>;
}
